module.exports = __webpack_public_path__ + "static/report/img/eagleeye.b0a8d8ea.png";